export default "__VITE_ASSET__6c432092__"